'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["menuItems", "className"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import StyleProtectedMenuButton from '../style-protected/StyleProtectedMenuButton';
import StyleProtectedUIMultiLevelDropdown from '../style-protected/StyleProtectedUIMultiLevelDropdown';
import withDisabledContext from '../hoc/withDisabledContext';
import { SUBMENU_STAY_OPEN_CLASSNAME, SUBMENU_CLOSE_CLASSNAME } from '../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SUB_DROPDOWN_CLASSNAME = 'mce-sub-menu';
class ToolbarMenu extends Component {
  constructor(...args) {
    super(...args);
    this.shouldCloseOnClick = ({
      target
    }) => {
      let parent = target;
      while (parent) {
        if (parent.classList.contains(SUB_DROPDOWN_CLASSNAME) || parent.classList.contains(this.props.dropdownClassName) || parent.classList.contains(SUBMENU_CLOSE_CLASSNAME)) {
          // Close the dropdown menu if bubbled up to the parent dropdown
          // component or found the "submenu close" classname
          return true;
        } else if (parent.classList.contains(SUBMENU_STAY_OPEN_CLASSNAME)) {
          // Don't close the dropdown if a parent component has the
          // "submenu stay open" classname
          return false;
        } else {
          parent = parent.parentElement;
        }
      }
      return true;
    };
    this.getOptionForMenuItem = menuItem => {
      let {
        child
      } = menuItem;
      if (!child) {
        return this.renderMenuItem(menuItem);
      }
      if (typeof child === 'function') {
        child = child();
      }
      return {
        label: menuItem.text,
        options: [child],
        iconName: menuItem.icon,
        dropdownClassName: SUB_DROPDOWN_CLASSNAME,
        'data-test-id': menuItem.name
      };
    };
  }
  renderMenuItem({
    name,
    onClick,
    text,
    render,
    icon,
    disabled,
    tooltip
  }) {
    if (typeof render === 'function') {
      return render({
        key: name
      });
    }
    const MenuButton = /*#__PURE__*/_jsxs(StyleProtectedMenuButton, {
      disabled: disabled,
      "data-test-id": name,
      onClick: onClick,
      children: [icon && /*#__PURE__*/_jsx(UIIcon, {
        name: icon
      }), text]
    }, name);
    if (typeof tooltip === 'object') {
      const {
        title,
        placement = 'bottom'
      } = tooltip;
      return /*#__PURE__*/_jsx(UITooltip, {
        className: "mce-toolbar-menu-tooltip",
        title: title,
        placement: placement,
        children: MenuButton
      });
    }
    return MenuButton;
  }
  render() {
    const _this$props = this.props,
      {
        menuItems,
        className
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(StyleProtectedUIMultiLevelDropdown, Object.assign({
      buttonClassName: className,
      buttonUse: "transparent",
      animateOnToggle: false,
      options: menuItems.map(this.getOptionForMenuItem),
      shouldCloseOnClick: this.shouldCloseOnClick
    }, rest));
  }
}
ToolbarMenu.propTypes = {
  menuItems: PropTypes.array.isRequired,
  className: PropTypes.string,
  dropdownClassName: PropTypes.string
};
export default withDisabledContext(ToolbarMenu);